import type { ComponentProps, ReactElement } from 'react';

import { cn } from '@/lib/utils.js';

/**
 * Центральная колонка страницы — замена `.mm-container` из снесённого styles/typography.css.
 *
 * ⚠️ Ширина ФИКСИРОВАННАЯ, а не ступенчатая. `.mm-container` воспроизводил лестницу
 * Bootstrap (540/720/960/1140/1320px через пять media-запросов), из-за чего колонка
 * прыгала на каждом брейкпоинте. В макете колонка одна — 1200px, и до неё страница
 * просто тянется по ширине окна.
 *
 * Поля тоже из макета: 20px на мобильном артборде (390) и 44px на десктопном (1200).
 * Это не отступы Bootstrap (12px), поэтому переносить старые значения нельзя —
 * логотип и первый абзац встанут ближе к краю, чем в макете.
 */
export function PageShell({ className, ...props }: ComponentProps<'div'>): ReactElement {
  return (
    <div className={cn('mx-auto w-full max-w-[1200px] px-5 md:px-11', className)} {...props} />
  );
}
